<template>
  <PortalWidget :widget="widgetTitle">
    <p />

    <BuyerRegistrationSettingsForm
      v-if="!isLoadingSettings"
      :setting="brpSettings"
    />

    <div
      v-if="isLoadingSettings"
      class="well well-sm text-center"
    >
      <Loader />
      <span v-t="'LOADING_SETTINGS'" />
    </div> 
  </PortalWidget>
</template>

<script>

import messages from '../../locales';
import PortalWidget from '@/core/components/PortalWidget.vue';
import Loader from '@/core/components/Loader';
import BuyerRegistrationSettingsForm from './BuyerRegistrationSettingsForm';
import { mapActions, mapState } from 'vuex';
import { STATUS_PENDING, getStatus } from '@/store/helpers';
import { LOAD_BRP_SETTINGS } from '../../store/actionTypes';

export default {
  components: { 
    PortalWidget,
    Loader,
    BuyerRegistrationSettingsForm
  },

  data() {
    return {
      widgetTitle: { title:this.$i18n.t('PAGE_TITLE'), iconClass: 'typcn typcn-group'}
    };
  },

  computed: {
    ...mapState('openRegistrationStore', {
      loadSettingsStatus: (state) => getStatus(state, LOAD_BRP_SETTINGS),
    }),
    ...mapState('openRegistrationStore', [
      'brpSettings',
    ]),
    isLoadingSettings() {
      return this.loadSettingsStatus.status == STATUS_PENDING;
    },
  },

  created() {
    this.loadBRPSettings();
  },

  methods: {
    ...mapActions('openRegistrationStore', [
      LOAD_BRP_SETTINGS,
    ]),
  },

  i18n: {
    messages,
    locale: 'en'
  }
};
</script>

<style>

</style>